module.exports = __webpack_public_path__ + "img/banner_mda.1df1f0aa.jpg";